<template>
  <div class="min-h-screen flex items-center justify-center bg-[#0f0f1a] text-gray-300">
    <div class="w-full max-w-md bg-[#1a1a2e] rounded-lg shadow-lg p-8">
      <h2 class="text-4xl font-bold text-center text-[#9a7af1] mb-6">Autentificare</h2>
      <form @submit.prevent="handleLogin">
        <div class="mb-4">
          <label class="block text-sm font-semibold mb-2" for="username">Username</label>
          <input
            v-model="username"
            id="username"
            type="text"
            placeholder="Introdu username-ul"
            class="w-full bg-[#0f0f1a] border border-gray-600 rounded py-2 px-4 focus:outline-none focus:ring-2 focus:ring-[#9a7af1]"
            required
          />
        </div>
        <div class="mb-6">
          <label class="block text-sm font-semibold mb-2" for="password">Parola</label>
          <input
            v-model="password"
            id="password"
            type="password"
            placeholder="Introdu parola"
            class="w-full bg-[#0f0f1a] border border-gray-600 rounded py-2 px-4 focus:outline-none focus:ring-2 focus:ring-[#9a7af1]"
            required
          />
        </div>
        <button
          type="submit"
          class="w-full bg-[#9a7af1] hover:bg-[#7d5fbf] text-white font-semibold py-2 px-4 rounded transition duration-300"
        >
          Autentificare
        </button>
      </form>
      <p v-if="errorMessage" class="text-red-500 text-center mt-4">{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import apiClient from "@/api/axiosInstance"; // Importăm instanța Axios

export default {
  name: "LoginView",
  data() {
    return {
      username: "",
      password: "",
      errorMessage: "",
    };
  },
  methods: {
    async handleLogin() {
      try {
        const response = await apiClient.post("/login", {
          username: this.username,
          password: this.password,
        });
        // Salvăm token-ul și rolul utilizatorului în localStorage
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("role", response.data.role);
        // Navigăm către Dashboard după autentificare
        this.$router.push({ name: "Dashboard" });
      } catch (error) {
        console.error("Eroare la autentificare:", error);
        this.errorMessage = "Username sau parola incorecte.";
      }
    },
  },
};
</script>
